import { render, staticRenderFns } from "./login-modal.vue?vue&type=template&id=15b71bf4&"
import script from "./login-modal.vue?vue&type=script&lang=js&"
export * from "./login-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports